import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref } from "vue"

const _hoisted_1 = { id: "results" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M9.57 5.93018L3.5 12.0002L9.57 18.0702M20.5 12.0002H3.67",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Resultado busca", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("input", {
  autocomplete: "off",
  type: "radio",
  name: "results",
  id: "results-docs",
  checked: ""
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "tab" }, [
  /*#__PURE__*/_createElementVNode("label", { for: "results-docs" }, "Documentos"),
  /*#__PURE__*/_createElementVNode("label", { for: "results-organizations" }, "Setores"),
  /*#__PURE__*/_createElementVNode("label", { for: "results-users" }, "Usuários")
], -1)
const _hoisted_7 = { class: "documents list" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Resultados para: "),
  /*#__PURE__*/_createElementVNode("strong", null, "DOCUMENTOS")
], -1)
const _hoisted_9 = {
  key: 1,
  class: "no-result"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "173",
  height: "173",
  viewBox: "0 0 173 173",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    opacity: "0.4",
    d: "M48.5143 142.004C54.4252 135.661 63.4354 136.165 68.6254 143.085L75.9059 152.817C81.7447 160.53 91.1875 160.53 97.0263 152.817L104.307 143.085C109.497 136.165 118.507 135.661 124.418 142.004C137.249 155.7 147.701 151.159 147.701 131.985V50.8186C147.701 21.769 140.925 14.4888 113.677 14.4888H59.1825C31.935 14.4888 25.1592 21.769 25.1592 50.8186V131.985C25.2313 151.159 35.7556 155.628 48.5143 142.004Z",
    fill: "#292D32"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M112.881 97.0963L107.547 91.7622C110.286 87.5814 111.944 82.5355 111.944 77.1293C111.944 62.4243 99.9782 50.4584 85.2732 50.4584C70.5682 50.4584 58.6025 62.4243 58.6025 77.1293C58.6025 91.8343 70.5682 103.8 85.2732 103.8C90.6795 103.8 95.7253 102.142 99.9061 99.403L105.24 104.737C106.322 105.818 107.691 106.323 109.061 106.323C110.43 106.323 111.8 105.818 112.881 104.737C114.972 102.647 114.972 99.1867 112.881 97.0963Z",
    fill: "#292D32"
  })
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h1", null, "Nada foi encontrado para sua busca", -1)
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "organizations list" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Resultados para: "),
  /*#__PURE__*/_createElementVNode("strong", null, "SETORES")
], -1)
const _hoisted_15 = {
  key: 1,
  class: "no-result"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "173",
  height: "173",
  viewBox: "0 0 173 173",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    opacity: "0.4",
    d: "M48.5143 142.004C54.4252 135.661 63.4354 136.165 68.6254 143.085L75.9059 152.817C81.7447 160.53 91.1875 160.53 97.0263 152.817L104.307 143.085C109.497 136.165 118.507 135.661 124.418 142.004C137.249 155.7 147.701 151.159 147.701 131.985V50.8186C147.701 21.769 140.925 14.4888 113.677 14.4888H59.1825C31.935 14.4888 25.1592 21.769 25.1592 50.8186V131.985C25.2313 151.159 35.7556 155.628 48.5143 142.004Z",
    fill: "#292D32"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M112.881 97.0963L107.547 91.7622C110.286 87.5814 111.944 82.5355 111.944 77.1293C111.944 62.4243 99.9782 50.4584 85.2732 50.4584C70.5682 50.4584 58.6025 62.4243 58.6025 77.1293C58.6025 91.8343 70.5682 103.8 85.2732 103.8C90.6795 103.8 95.7253 102.142 99.9061 99.403L105.24 104.737C106.322 105.818 107.691 106.323 109.061 106.323C110.43 106.323 111.8 105.818 112.881 104.737C114.972 102.647 114.972 99.1867 112.881 97.0963Z",
    fill: "#292D32"
  })
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h1", null, "Nada foi encontrado para sua busca", -1)
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "users" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Resultados para: "),
  /*#__PURE__*/_createElementVNode("strong", null, "USUÁRIOS")
], -1)
const _hoisted_21 = {
  key: 1,
  class: "no-result"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "173",
  height: "173",
  viewBox: "0 0 173 173",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    opacity: "0.4",
    d: "M48.5143 142.004C54.4252 135.661 63.4354 136.165 68.6254 143.085L75.9059 152.817C81.7447 160.53 91.1875 160.53 97.0263 152.817L104.307 143.085C109.497 136.165 118.507 135.661 124.418 142.004C137.249 155.7 147.701 151.159 147.701 131.985V50.8186C147.701 21.769 140.925 14.4888 113.677 14.4888H59.1825C31.935 14.4888 25.1592 21.769 25.1592 50.8186V131.985C25.2313 151.159 35.7556 155.628 48.5143 142.004Z",
    fill: "#292D32"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M112.881 97.0963L107.547 91.7622C110.286 87.5814 111.944 82.5355 111.944 77.1293C111.944 62.4243 99.9782 50.4584 85.2732 50.4584C70.5682 50.4584 58.6025 62.4243 58.6025 77.1293C58.6025 91.8343 70.5682 103.8 85.2732 103.8C90.6795 103.8 95.7253 102.142 99.9061 99.403L105.24 104.737C106.322 105.818 107.691 106.323 109.061 106.323C110.43 106.323 111.8 105.818 112.881 104.737C114.972 102.647 114.972 99.1867 112.881 97.0963Z",
    fill: "#292D32"
  })
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h1", null, "Nada foi encontrado para sua busca", -1)
const _hoisted_24 = { class: "itens" }
const _hoisted_25 = ["onClick"]

import { useAxios } from '@/api/axios'
import SpinnerLoader from '@/components/loader/SpinnerLoader.vue'
import { DocumentModel } from '@/models/DocumentModel'
import { OrganizationModel } from '@/models/OrganizationModel'
import PaginationModel from '@/models/PaginationModel'
import { UserModel } from '@/models/UserModel'
import { AxiosResponse } from 'axios'
import { onMounted, ref } from 'vue'
import { user as authenticatedUser } from '@/global/states/GlobalState'


export default /*#__PURE__*/_defineComponent({
  __name: 'ResultsView',
  props: {
    search: {}
  },
  setup(__props: any) {

const props = __props
const loaders = ref({ documents: false, organizations: true, users: false })
const axios = useAxios()
const documentPagination = ref<PaginationModel<DocumentModel>>()
const organizations = ref<OrganizationModel[]>()
const users = ref<UserModel[]>()

onMounted(() => {
  getDocuments()
})

function getDocuments () {
  loaders.value.documents = true
  axios.get('/api/documents', { params: { search: props.search } })
    .then((res: AxiosResponse<PaginationModel<DocumentModel>>) => {
      documentPagination.value = res.data
    }).finally(() => loaders.value.documents = false)
}

function getOrganizations () {
  loaders.value.organizations = true
  axios.get('/api/organizations', { params: { search: props.search } })
    .then((res: AxiosResponse<OrganizationModel[]>) => {
      organizations.value = res.data
    }).finally(() => loaders.value.organizations = false)
}

function getUsers () {
  loaders.value.users = true
  axios.get('/api/users', { params: { search: props.search } })
    .then((res: AxiosResponse<UserModel[]>) => {
      users.value = res.data
    }).finally(() => loaders.value.users = false)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/admin/home'))),
      class: "back"
    }, _hoisted_4),
    _hoisted_5,
    _createElementVNode("input", {
      autocomplete: "off",
      type: "radio",
      name: "results",
      id: "results-organizations",
      onChange: _cache[1] || (_cache[1] = ($event: any) => (($event.target as HTMLInputElement).checked && !organizations.value ? getOrganizations() : ''))
    }, null, 32),
    _createElementVNode("input", {
      autocomplete: "off",
      type: "radio",
      name: "results",
      id: "results-users",
      onChange: _cache[2] || (_cache[2] = ($event: any) => (($event.target as HTMLInputElement).checked && !users.value ? getUsers() : ''))
    }, null, 32),
    _createElementVNode("main", null, [
      _hoisted_6,
      _createElementVNode("section", _hoisted_7, [
        _hoisted_8,
        (loaders.value.documents)
          ? (_openBlock(), _createBlock(SpinnerLoader, { key: 0 }))
          : _createCommentVNode("", true),
        (!documentPagination.value?.data?.length && !loaders.value.documents)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _hoisted_10,
              _hoisted_11,
              _createElementVNode("p", null, [
                _createElementVNode("a", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (getDocuments()))
                }, "Clique aqui"),
                _createTextVNode(" e tente novamente")
              ])
            ]))
          : (documentPagination.value)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(documentPagination.value.data, (document) => {
                return (_openBlock(), _createElementBlock("section", {
                  onClick: ($event: any) => (_ctx.$router.push({ name: 'admin.documents.show', params: { id: document.id } }))
                }, [
                  _createElementVNode("h2", null, [
                    _createTextVNode("Ofício "),
                    _createElementVNode("strong", null, "Nº " + _toDisplayString(document.number), 1)
                  ]),
                  _createElementVNode("h1", null, _toDisplayString(document.title), 1),
                  _createElementVNode("h2", null, _toDisplayString(document.organizations[0]?.name), 1)
                ], 8, _hoisted_12))
              }), 256))
            : _createCommentVNode("", true)
      ]),
      _createElementVNode("section", _hoisted_13, [
        _hoisted_14,
        (loaders.value.organizations)
          ? (_openBlock(), _createBlock(SpinnerLoader, { key: 0 }))
          : (!organizations.value?.length && !loaders.value.organizations)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _hoisted_16,
                _hoisted_17,
                _createElementVNode("p", null, [
                  _createElementVNode("a", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (getOrganizations()))
                  }, "Clique aqui"),
                  _createTextVNode(" e tente novamente")
                ])
              ]))
            : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organizations.value, (organization) => {
          return (_openBlock(), _createElementBlock("section", {
            onClick: ($event: any) => (_ctx.$router.push({ name: _unref(authenticatedUser)?.can!('update_organizations') ? 'admin.organizations.edit' : 'admin.users.index', params: { id: organization.id } }))
          }, [
            _createElementVNode("h1", null, _toDisplayString(organization.name), 1),
            _createElementVNode("h2", null, _toDisplayString(organization.acronym), 1)
          ], 8, _hoisted_18))
        }), 256))
      ]),
      _createElementVNode("section", _hoisted_19, [
        _hoisted_20,
        (loaders.value.users)
          ? (_openBlock(), _createBlock(SpinnerLoader, { key: 0 }))
          : (!users.value?.length && !loaders.value.users)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _hoisted_22,
                _hoisted_23,
                _createElementVNode("p", null, [
                  _createElementVNode("a", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (getUsers()))
                  }, "Clique aqui"),
                  _createTextVNode(" e tente novamente")
                ])
              ]))
            : _createCommentVNode("", true),
        _createElementVNode("section", null, [
          _createElementVNode("div", _hoisted_24, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(users.value, (user) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                onClick: ($event: any) => (_ctx.$router.push({ name: _unref(authenticatedUser)?.can!('update_users') ? 'admin.users.edit' : 'admin.users.index', params: { id: user.id } }))
              }, [
                _createElementVNode("h1", null, _toDisplayString(user.name), 1),
                _createElementVNode("h2", null, _toDisplayString(user.organization?.acronym ?? 'sem setor'), 1)
              ], 8, _hoisted_25))
            }), 256))
          ])
        ])
      ])
    ])
  ]))
}
}

})